<section id="src-ext-per-dealership-maint">    
    <div class="mtn-container">
        <div class="mtn-title">
            <p>{{ moduleName }}</p>
        </div>
        <div class="form-content">
            <form [formGroup]="forms.agentLovForm" class="form">
                <div class="form-container-grid top-form">
                    <div class="field required">
                        <label>Dealership</label>
                    </div>
                    <div class="">
                        <input formControlName="agentCdDisp" >
                        <button matSuffix class="btn btn-search" type="button" (click)="openLov['agent']()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <!-- Container for Source Extension Code Per Dealership Table using prime ng -->
        <div class = 'table-user'>
            <osp-table [tblConfig]="srcExtPerDealershipTblConfig" (onRowClick)="onRowClick($event)"></osp-table>
        </div>
        <!-- Loading Animation -->
        <div id="src-ext-per-dealership-maintenance-loading">
            <div class="form-loader"></div>
        </div>
        <div class="form-content" *ngIf="showForm">
            <form [formGroup]="forms.srcExtPerDealershipForm" class="form">
                <div id="src-ext-per-dealership-error-message"></div>
                <div class="form-container-grid">
                    <div class="field required">
                        <label>Source Extension</label>
                    </div>
                    <div class="span lov-search">
                        <input type="text" readonly formControlName="srcExtField">
                        <button type="button" class="btn-search btn" (click)="openLov['srcExt']()" [disabled]='btns.srcExtPerDealership.srcExtDisabled'>
                            <mat-icon>
                                search
                            </mat-icon>
                        </button>
                    </div>

                    <div class="field required">
                        <label>Active</label>
                    </div>
                    <div class="">
                        <select formControlName="activeTag">
                            <option *ngFor="let activeType of selections.activeTypes" [value]="activeType.cd">
                                {{activeType.name}}
                            </option>
                        </select>
                    </div>

                    <div></div>
                    <div></div>

                    <div class="field">
                        <label>Remarks</label>
                    </div>
                    <div class="span">
                        <input formControlName="remarks" type="text" maxlength="4000">
                    </div>

                    <div class="field">
                        <label>Last Update User</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUser">
                    </div>
                    <div class="field">
                        <label>Last Update</label>
                    </div>
                    <div class="">
                        <input type="text" readonly formControlName="lastUpdate">
                    </div>
                </div>
            </form>
            <div class="btn-row">
                <button *ngIf="btns.srcExtPerDealership.updateDisabled" class="btn btn2" type="button" [disabled]='btns.srcExtPerDealership.addDisabled' (click)="onAdd()">ADD</button>
                <button *ngIf="!btns.srcExtPerDealership.updateDisabled" class="btn btn2" type="button" (click)="onUpdate()">UPDATE</button>
                <button class="btn btn2" type="button" [disabled]='btns.srcExtPerDealership.deleteDisabled' (click)="onDelete()">DELETE</button>
            </div>
            <div class="mtn-title"></div>
            <div class="btn-row">
                <button class="btn btn2" type="button" [disabled]='btns.srcExtPerDealership.saveDisabled' (click)="onSave()">SAVE</button>
            </div>
        </div>
    </div>
</section>